export default class Year {
  constructor(element) {
    this.element = element;

    this.init();
  }

  init() {
    const currentYear = new Date().getFullYear();
    this.element.querySelector('.year').textContent = currentYear;
  }
}
